import { LicenseStatusDto } from '../dtos/license-status.dto';
import { LicenseStatus } from '../models/license-status';

/**
 * Map license status from dto.
 * @param {LicenseStatusDto} dto Dto.
 * @returns {LicenseStatus}
 */
function fromDto(dto) {
  return {
    id: dto.id,
    name: dto.name,
    description: dto.description,
  };
}

export const licenseStatusMapper = {
  fromDto,
};
